
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { INTERVIEW_SEARCHED_JOB } from "@/store/modules/recruiter/constants";
import {
  CANDIDATE_INTERVIEW_SEARCH_JOB_LOADING,
  GET_JOBS_LOADING,
  SEARCH_ANY_JOB
} from "@/store/modules/candidates/constants";
import AutoCompleteCandidateJobSearch from "@/components/shared/jobs/AutoCompleteCandidateJobSearch.vue";
import { SearchJobObject } from "@/interfaces/shared/jobs/auto_complete_job_search";
import { Interview } from "@/interfaces/responses/interviews/interviews";

export default Vue.extend({
  name: "CandidateInterviewListingHeader",
  components: { AutoCompleteCandidateJobSearch },
  data() {
    return {
      selectedStatus: "all" as string | null
    };
  },
  computed: {
    ...mapGetters("candidate", {
      jobs_loading: GET_JOBS_LOADING
    }),
    ...mapGetters("recruiter", {
      get_searched_job: INTERVIEW_SEARCHED_JOB
    }),
    statusOptions() {
      return [
        { text: this.$t("candidate.interview.status.all", "All"), value: "all" },
        { text: this.$t("candidate.interview.status.cancelled", "Cancelled"), value: Interview.Status.CANCELLED },
        { text: this.$t("candidate.interview.status.completed", "Completed"), value: Interview.Status.Finished }
      ];
    }
  },
  watch: {
    '$i18n.locale'() {
      // Force reactivity when locale changes
      this.$forceUpdate();
    }
  },
  created() {
    // Ensure translations are loaded
    this.$forceUpdate();
  },
  methods: {
    ...mapMutations("recruiter", {
      set_searched_job: INTERVIEW_SEARCHED_JOB
    }),
    ...mapMutations("candidate", {
      set_search_job_loading: CANDIDATE_INTERVIEW_SEARCH_JOB_LOADING
    }),
    ...mapActions("candidate", {
      search_any_job: SEARCH_ANY_JOB
    }),
    handleSearchJob(value: SearchJobObject | null): void {
      value
        ? (this as any).set_search_job_loading(true)
        : (this as any).set_search_job_loading(false);
      (this as any).set_searched_job(value);
    },
    handleStatusChange(): void {
      this.$emit('status-filter-changed', (this as any).selectedStatus);
    }
  }
});
